module.exports = __webpack_public_path__ + "static/media/right_layout_image_Car_M.e60ed50f.svg";